"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lighter_success = exports.light_success = exports.success = exports.secondary = exports.primary = exports.source_to_you = exports.healing_hands = exports.healthcare = exports.danger_maybe = exports.warning_maybe = exports.success_maybe = exports.color_white = exports.light_grey = exports.grey = exports.lighter_blue = exports.light_blue = exports.deep_blue = exports.darkest_lavender = exports.darker_lavender = exports.middle_lavender = exports.dark_lavender = exports.deep_lavender = exports.lavender = exports.pale_lavender = exports.lighter_lavender = exports.lighter_body_blue = exports.light_body_blue = exports.body_blue = exports.cyan = exports.teal = exports.green2 = exports.green = exports.yellow = exports.orange = exports.red = exports.pink = exports.purple = exports.indigo = exports.blue = exports.black = exports.gray_900 = exports.gray_800 = exports.gray_700 = exports.gray_600 = exports.gray_500 = exports.gray_400 = exports.gray_300 = exports.gray_200 = exports.gray_100 = exports.white = void 0;
exports.DoterraReactSelectTheme = exports.dark = exports.light = exports.lighter_danger = exports.light_danger = exports.danger = exports.lighter_warning = exports.light_warning = exports.warning = exports.info = void 0;
exports.white = '#fff';
exports.gray_100 = '#f8f9fa';
exports.gray_200 = '#e9ecef';
exports.gray_300 = '#dee2e6';
exports.gray_400 = '#ced4da';
exports.gray_500 = '#adb5bd';
exports.gray_600 = '#6c757d';
exports.gray_700 = '#495057';
exports.gray_800 = '#343a40';
exports.gray_900 = '#212529';
exports.black = '#000';
exports.blue = '#007bff';
exports.indigo = '#6610f2';
exports.purple = '#6f42c1';
exports.pink = '#e83e8c';
exports.red = '#dc3545';
exports.orange = '#fd7e14';
exports.yellow = '#ffc107';
exports.green = '#28a745';
exports.green2 = '#00991D';
exports.teal = '#20c997';
exports.cyan = '#17a2b8';
exports.body_blue = '#354657';
exports.light_body_blue = '#4e657e';
exports.lighter_body_blue = '#C1C7CD';
exports.lighter_lavender = '#F5EEF7';
exports.pale_lavender = '#E4B5EA';
exports.lavender = '#BD8BCA';
exports.deep_lavender = '#A25EB5';
exports.dark_lavender = '#9D57B2';
exports.middle_lavender = '#8A4F8E';
exports.darker_lavender = '#773C7C';
exports.darkest_lavender = '#663766';
exports.deep_blue = '#0067DC';
exports.light_blue = '#95C0F1';
exports.lighter_blue = '#F4F8FD';
exports.grey = '#D1D1D1';
exports.light_grey = '#EEEEEE';
exports.color_white = '#fff';
exports.success_maybe = '#7BB739';
exports.warning_maybe = '#F8B259';
exports.danger_maybe = '#DE6C6C';
exports.healthcare = '#00A9D0';
exports.healing_hands = '#F4364C';
exports.source_to_you = '#81C28A';
exports.primary = exports.lavender;
exports.secondary = exports.gray_600;
exports.success = exports.green2;
exports.light_success = '#CAE2B0';
exports.lighter_success = '#F1F7EB';
exports.info = exports.cyan;
exports.warning = exports.yellow;
exports.light_warning = '#FCE0BD';
exports.lighter_warning = '#FEF7EE';
exports.danger = exports.red;
exports.light_danger = '#F2C4C4';
exports.lighter_danger = '#FBF0F0';
exports.light = exports.gray_100;
exports.dark = exports.gray_800;
const DoterraReactSelectTheme = (theme) => (Object.assign(Object.assign({}, theme), { colors: Object.assign(Object.assign({}, theme.colors), { primary: exports.dark_lavender, primary75: exports.deep_lavender, primary50: exports.lavender, primary25: exports.pale_lavender }) }));
exports.DoterraReactSelectTheme = DoterraReactSelectTheme;
